.bt{flex-wrap:wrap;}